import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';
import Routes from './routes';
import { AuthProvider } from './hooks/useAuth';
import GlobalStyles from './styles/global';

const App = () => {
  return (
    <BrowserRouter basename={process.env.FOLDER_NAME}>
      <GlobalStyles />
      <AuthProvider>
        <Routes />
      </AuthProvider>
      <ToastContainer autoClose={3000} />
    </BrowserRouter>
  );
};

export default App;
